import { graphql } from "react-relay";
import "@components/event-summary/EventSummaryRecurrence.gql";
import "@components/event-summary/EventSummaryAutopilot.gql";
import "@components/event-summary/EventSummaryTime.gql";

export const fragments = {
  org: graphql`
    fragment AutopilotList_org on Org
    @argumentDefinitions(timeZone: { type: "String!" }, calendarId: { type: "String!" }) {
      ...EventSummaryAutopilot_org
      ...EventSummaryTime_org
      ...EventSummaryRecurrence_org
      id
      experiments
      focusTimeSavedInHours
      primaryOrgEmail
      primaryOrgCalendar
      autopilotEventsResponse(timeZone: $timeZone) {
        __typename
        ... on AutopilotEventsResponse {
          enabledOrganized {
            ...EventSummaryTime_event
            ...EventSummaryRecurrence_event
            ...EventSummaryAutopilot_event @arguments(calendarId: $calendarId)

            suggestedAutopilotSettingsResponseV3 {
              __typename
              ... on SuggestedAutopilotSettingsResponseV3 {
                intersectionOfAttendeesMeetingHours {
                  minSlot {
                    dayOffset
                    timeSlot
                  }
                  maxSlot {
                    dayOffset
                    timeSlot
                  }
                }
                calendarIdToMeetingHours {
                  calendarId
                  dayOffsetTimeSlotRanges {
                    minSlot {
                      dayOffset
                      timeSlot
                    }
                    maxSlot {
                      dayOffset
                      timeSlot
                    }
                  }
                }
                suggestedAutopilotSettings {
                  isRoomFlexible
                  movementType
                  allowedEndTime {
                    dayOffset
                    timeSlot
                  }
                  allowedStartTime {
                    dayOffset
                    timeSlot
                  }
                }
              }
              ... on GraphEntityError {
                message
              }
            }
            moveRangeInLocalTimeV3 {
              __typename
              ... on MoveRangeInLocalTimeV3 {
                allowedStartTimeInclusive {
                  dayOffset
                  timeSlot
                }
                allowedEndTimeInclusive {
                  dayOffset
                  timeSlot
                }
              }
              ... on GraphEntityError {
                message
              }
            }

            recurrenceRules {
              timeZone
            }

            annotatedEvent {
              orgTags {
                tag
                state {
                  active
                  value
                  subjectType
                }
              }
            }

            title
            createdMillis
            isClockwiseEvent
            eventKey {
              externalEventId
            }
            organizer {
              urnValue
            }
            startTime {
              millis
            }
            endTime {
              millis
            }
          }
          enabledAttending {
            ...EventSummaryTime_event
            ...EventSummaryRecurrence_event
            ...EventSummaryAutopilot_event @arguments(calendarId: $calendarId)

            recurrenceRules {
              timeZone
            }

            annotatedEvent {
              orgTags {
                tag
                state {
                  active
                  value
                  subjectType
                }
              }
            }

            title
            createdMillis
            isClockwiseEvent
            eventKey {
              externalEventId
            }
            organizer {
              urnValue
              displayName
            }
            startTime {
              millis
            }
            endTime {
              millis
            }
          }
          suggestedOrganized {
            ...EventSummaryTime_event
            ...EventSummaryRecurrence_event
            ...EventSummaryAutopilot_event @arguments(calendarId: $calendarId)

            suggestedAutopilotSettingsResponseV3 {
              __typename
              ... on SuggestedAutopilotSettingsResponseV3 {
                intersectionOfAttendeesMeetingHours {
                  minSlot {
                    dayOffset
                    timeSlot
                  }
                  maxSlot {
                    dayOffset
                    timeSlot
                  }
                }
                calendarIdToMeetingHours {
                  calendarId
                  dayOffsetTimeSlotRanges {
                    minSlot {
                      dayOffset
                      timeSlot
                    }
                    maxSlot {
                      dayOffset
                      timeSlot
                    }
                  }
                }
                suggestedAutopilotSettings {
                  isRoomFlexible
                  movementType
                  allowedEndTime {
                    dayOffset
                    timeSlot
                  }
                  allowedStartTime {
                    dayOffset
                    timeSlot
                  }
                }
              }
              ... on GraphEntityError {
                message
              }
            }
            moveRangeInLocalTimeV3 {
              __typename
              ... on MoveRangeInLocalTimeV3 {
                allowedStartTimeInclusive {
                  dayOffset
                  timeSlot
                }
                allowedEndTimeInclusive {
                  dayOffset
                  timeSlot
                }
              }
              ... on GraphEntityError {
                message
              }
            }

            recurrenceRules {
              timeZone
            }

            annotatedEvent {
              orgTags {
                tag
                state {
                  active
                  value
                  subjectType
                }
              }
            }

            title
            createdMillis
            isClockwiseEvent
            eventKey {
              externalEventId
            }
            organizer {
              urnValue
            }
            startTime {
              millis
            }
            endTime {
              millis
            }
          }
          suggestedAttending {
            ...EventSummaryTime_event
            ...EventSummaryRecurrence_event
            ...EventSummaryAutopilot_event @arguments(calendarId: $calendarId)

            recurrenceRules {
              timeZone
            }

            suggestedAutopilotSettingsResponseV3 {
              __typename
              ... on SuggestedAutopilotSettingsResponseV3 {
                intersectionOfAttendeesMeetingHours {
                  minSlot {
                    dayOffset
                    timeSlot
                  }
                  maxSlot {
                    dayOffset
                    timeSlot
                  }
                }
                calendarIdToMeetingHours {
                  calendarId
                  dayOffsetTimeSlotRanges {
                    minSlot {
                      dayOffset
                      timeSlot
                    }
                    maxSlot {
                      dayOffset
                      timeSlot
                    }
                  }
                }
                suggestedAutopilotSettings {
                  isRoomFlexible
                  movementType
                  allowedEndTime {
                    dayOffset
                    timeSlot
                  }
                  allowedStartTime {
                    dayOffset
                    timeSlot
                  }
                }
              }
              ... on GraphEntityError {
                message
              }
            }

            annotatedEvent {
              orgTags {
                tag
                state {
                  active
                  value
                  subjectType
                }
              }
            }

            title
            createdMillis
            isClockwiseEvent
            eventKey {
              externalEventId
            }
            organizer {
              urnValue
            }
            startTime {
              millis
            }
            endTime {
              millis
            }
          }
        }
        ... on GraphEntityError {
          message
        }
      }
    }
  `,
  orgRefetch: graphql`
    fragment AutopilotList_orgRefetch on Org
    @argumentDefinitions(
      userCalendarIds: { type: "[String!]!", defaultValue: [] }
      calendarIds: { type: "[String]!", defaultValue: [] }
      externalEventIds: { type: "[String!]!", defaultValue: [] }
    ) {
      personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
        __typename
        ... on PersonList {
          list {
            id
            emails
            primaryEmail
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
            userId
          }
        }
        ... on GraphEntityError {
          message
        }
      }
      canScheduleResponse(externalEventIds: $externalEventIds, calendarIds: $userCalendarIds) {
        __typename
        ... on CanScheduleResponseList {
          list {
            externalEventId
            canAutopilot
          }
        }
      }
    }
  `,
};

export const query = graphql`
  query AutopilotListRendererQuery(
    $orgRelayId: ID!
    $timeZone: String!
    $calendarId: String!
    $userCalendarIds: [String!]!
    $calendarIds: [String]!
    $externalEventIds: [String!]!
  ) {
    org: node(id: $orgRelayId) {
      ... on Org {
        ...AutopilotList_org @arguments(timeZone: $timeZone, calendarId: $calendarId)
        ...AutopilotList_orgRefetch
          @arguments(
            calendarIds: $calendarIds
            userCalendarIds: $userCalendarIds
            externalEventIds: $externalEventIds
          )
      }
    }
  }
`;

export const refetchQuery = graphql`
  query AutopilotListQuery(
    $orgRelayId: ID!
    $calendarIds: [String]!
    $externalEventIds: [String]!
    $userCalendarIds: [String!]!
  ) {
    orgRefetch: node(id: $orgRelayId) {
      ... on Org {
        ...AutopilotList_orgRefetch
          @arguments(
            calendarIds: $calendarIds
            externalEventIds: $externalEventIds
            userCalendarIds: $userCalendarIds
          )
      }
    }
  }
`;
